import { render, staticRenderFns } from "./apple_callback_page.vue?vue&type=template&id=4899c721&scoped=true"
import script from "./apple_callback_page.vue?vue&type=script&lang=js"
export * from "./apple_callback_page.vue?vue&type=script&lang=js"
import style0 from "./apple_callback_page.vue?vue&type=style&index=0&id=4899c721&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4899c721",
  null
  
)

export default component.exports